import wpstgHoverIntent from './modules/wpstg-hover-intent';
import WpstgDetectMemoryExhaust from './modules/wpstg-detect-memory-exhaust.js';

export default (function($) {
  const WPStagingCommon = {
    continueErrorHandle: true,
    retry: {
      currentDelay: 0,
      count: 0,
      max: 10,
      retryOnErrors: [401, 403, 404, 429, 502, 503, 504],
      performingRequest: false,
      incrementRetry: function(incrementRatio = 1.25) {
        WPStagingCommon.retry.performingRequest = true;
        if (WPStagingCommon.retry.currentDelay === 0) {
          // start with a delay of 1sec
          WPStagingCommon.retry.currentDelay = 1000;
          WPStagingCommon.retry.count = 1;
        }

        WPStagingCommon.retry.currentDelay += (500 * WPStagingCommon.retry.count * incrementRatio);
        WPStagingCommon.retry.count++;
      },
      canRetry: function() {
        return WPStagingCommon.retry.count < WPStagingCommon.retry.max;
      },
      reset: function() {
        WPStagingCommon.retry.currentDelay = 0;
        WPStagingCommon.retry.count = 0;
        WPStagingCommon.retry.performingRequest = false;
      },
    },
    memoryExhaustArticleLink: 'https://wp-staging.com/docs/php-fatal-error-allowed-memory-size-of-134217728-bytes-exhausted/',
    cache: {
      elements: [],
      get: function(selector) {
        // It is already cached!
        if ($.inArray(selector, this.elements) !== -1) {
          return this.elements[selector];
        }

        // Create cache and return
        this.elements[selector] = $(selector);

        return this.elements[selector];
      },
      refresh: function(selector) {
        selector.elements[selector] = $(selector);
      },
    },
    setJobId: function(jobId) {
      localStorage.setItem('jobIdBeingProcessed', jobId);
    },
    getJobId: function() {
      return localStorage.getItem('jobIdBeingProcessed');
    },
    async checkMemoryExhaustion(requestType) {
      const detectMemoryExhaust = new WpstgDetectMemoryExhaust();
      const response = await detectMemoryExhaust.sendRequest(requestType);

      if (!response) {
        return false;
      }

      return response;

      response.messages = [{
        'type': 'critical',
        'date': result.data['time'],
        'message': result.message + '. Read <a target="_blank" href="' + WPStagingCommon.memoryExhaustArticleLink + '">this article</a> for solving this issue. Please contact WP Staging support if you need further assistance.',
      }];

      WPStagingBackup.processResponse(response);

      return true;
    },
    listenTooltip: function() {
      wpstgHoverIntent(document, '.wpstg--tooltip', function(target, event) {
        target.querySelector('.wpstg--tooltiptext').style.visibility = 'visible';
      }, function(target, event) {
        if (!event.target.closest('.wpstg--tooltiptext a')) {
          target.querySelector('.wpstg--tooltiptext').style.visibility = 'hidden';
        }
      });
    },
    // Get the custom themed Swal Modal for WP Staging
    // Easy to maintain now in one place now
    getSwalModal: function(isContentCentered = false, customClasses = {}) {
      // common style for all swal modal used in WP Staging
      const defaultCustomClasses = {
        confirmButton: 'wpstg--btn--confirm wpstg-blue-primary wpstg-button wpstg-link-btn wpstg-100-width',
        cancelButton: 'wpstg--btn--cancel wpstg-blue-primary wpstg-link-btn wpstg-100-width',
        actions: 'wpstg--modal--actions',
        popup: isContentCentered ? 'wpstg-swal-popup wpstg-centered-modal' : 'wpstg-swal-popup',
      };

      // If an attribute exists in both default and additional attributes,
      // The class(es) of the additional attribute will overwrite the default one.
      const options = {
        customClass: Object.assign(defaultCustomClasses, customClasses),
        buttonsStyling: false,
        reverseButtons: true,
        showClass: {
          popup: 'wpstg--swal2-show wpstg-swal-show',
        },
      };

      return wpstgSwal.mixin(options);
    },
    showSuccessModal: function(htmlContent) {
      this.getSwalModal().fire({
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: 'OK',
        icon: 'success',
        title: 'Success!',
        html: '<div class="wpstg--grey" style="text-align: left; margin-top: 8px;">' + htmlContent + '</div>',
      });
    },
    showWarningModal: function(htmlContent) {
      this.getSwalModal().fire({
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: 'OK',
        icon: 'warning',
        title: '',
        html: '<div class="wpstg--grey" style="text-align: left; margin-top: 8px;">' + htmlContent + '</div>',
      });
    },
    showErrorModal: function(htmlContent) {
      this.getSwalModal().fire({
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: 'OK',
        icon: 'error',
        title: 'Error!',
        html: '<div class="wpstg--grey" style="text-align: left; margin-top: 8px;">' + htmlContent + '</div>',
      });
    },
    getSwalContainer: function() {
      return wpstgSwal.getContainer();
    },
    closeSwalModal: function() {
      wpstgSwal.close();
    },
    /**
     * Treats a default response object generated by WordPress's
     * wp_send_json_success() or wp_send_json_error() functions in
     * PHP, parses it in JavaScript, and either throws if it's an error,
     * or returns the data if the response is successful.
     *
     * @param {object} response
     * @return {*}
     */
    getDataFromWordPressResponse(response) {
      if (typeof response !== 'object') {
        throw new Error('Unexpected response (ERR 1341)');
      }

      if (!response.hasOwnProperty('success')) {
        throw new Error('Unexpected response (ERR 1342)');
      }

      if (!response.hasOwnProperty('data')) {
        throw new Error('Unexpected response (ERR 1343)');
      }

      if (response.success === false) {
        if (response.data instanceof Array && response.data.length > 0) {
          throw new Error(response.data.shift());
        } else {
          throw new Error('Response was not successful');
        }
      } else {
        // Successful response. Return the data.
        return response.data;
      }
    },
    isLoading: function(isLoading) {
      if (!isLoading || isLoading === false) {
        WPStagingCommon.cache.get('.wpstg-loader').hide();
      } else {
        WPStagingCommon.cache.get('.wpstg-loader').show();
      }
    },
    /**
     * Convert the given url to make it slug compatible
     * @param {string} url
     * @return {string}
     */
    slugify: function(url) {
      return url.toString()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/\s+/g, '-')
          .replace(/&/g, '-and-')
          .replace(/[^a-z0-9\-]/g, '')
          .replace(/-+/g, '-')
          .replace(/^-*/, '')
          .replace(/-*$/, '')
      ;
    },
    showAjaxFatalError: function(response, prependMessage, appendMessage) {
      prependMessage = prependMessage ? prependMessage + '<br/><br/>' : 'Something went wrong! <br/><br/>';
      appendMessage = appendMessage ? appendMessage + '<br/><br/>' : '<br/><br/>Please try the <a href=\'https://wp-staging.com/docs/wp-staging-settings-for-small-servers/\' target=\'_blank\'>WP Staging Small Server Settings</a> or submit an error report and contact us.';

      if (response === false) {
        WPStagingCommon.showError(prependMessage + ' Error: No response.' + appendMessage);
        window.removeEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);
        return;
      }

      if (typeof response.error !== 'undefined' && response.error) {
        WPStagingCommon.showError(prependMessage + ' Error: ' + response.message + appendMessage);
        window.removeEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);
        return;
      }
    },
    handleFetchErrors: function(response) {
      if (!response.ok) {
        WPStagingCommon.showError('Error: ' + response.status + ' - ' + response.statusText + '. Please try again or contact support.');
      }
      return response;
    },
    showError: function(message) {
      // If retry request no need to show Error;
      if (WPStagingCommon.retry.performingRequest) {
        return;
      }

      WPStagingCommon.cache.get('#wpstg-try-again').css('display', 'inline-block');
      WPStagingCommon.cache.get('#wpstg-cancel-cloning').text('Reset');
      WPStagingCommon.cache.get('#wpstg-resume-cloning').show();
      WPStagingCommon.cache.get('#wpstg-error-wrapper').show();
      WPStagingCommon.cache.get('#wpstg-error-details').show().html(message);
      WPStagingCommon.cache.get('#wpstg-removing-clone').removeClass('loading');
      WPStagingCommon.cache.get('.wpstg-loader').hide();
      $('.wpstg--modal--process--generic-problem').show().html(message);
    },
    resetErrors: function() {
      WPStagingCommon.cache.get('#wpstg-error-details').hide().html('');
    },
    /**
     * Ajax Requests
     * @param {Object} data
     * @param {Function} callback
     * @param {string} dataType
     * @param {bool} showErrors
     * @param {int} tryCount
     * @param {float} incrementRatio
     * @param {function} errorCallback
     */
    ajax: function(data, callback, dataType, showErrors, tryCount, incrementRatio = null, errorCallback = null) {
      if ('undefined' === typeof (dataType)) {
        dataType = 'json';
      }

      if (false !== showErrors) {
        showErrors = true;
      }

      tryCount = 'undefined' === typeof (tryCount) ? 0 : tryCount;

      const retryLimit = 10;

      let retryTimeout = 10000 * tryCount;

      incrementRatio = parseInt(incrementRatio);
      if (!isNaN(incrementRatio)) {
        retryTimeout *= incrementRatio;
      }

      $.ajax({
        url: ajaxurl + '?action=wpstg_processing&_=' + (Date.now() / 1000),
        type: 'POST',
        dataType: dataType,
        cache: false,
        data: data,
        error: function(xhr, textStatus, errorThrown) {
          console.log(xhr.status + ' ' + xhr.statusText + '---' + textStatus);

          if (typeof (errorCallback) === 'function') {
            // Custom error handler
            errorCallback(xhr, textStatus, errorThrown);

            if (!WPStagingCommon.continueErrorHandle) {
              // Reset state
              WPStagingCommon.continueErrorHandle = true;

              return;
            }
          }

          // Default error handler
          tryCount++;
          if (tryCount <= retryLimit) {
            setTimeout(function() {
              WPStagingCommon.ajax(data, callback, dataType, showErrors, tryCount, incrementRatio);
              return;
            }, retryTimeout);
          } else {
            const errorCode = 'undefined' === typeof (xhr.status) ? 'Unknown' : xhr.status;
            WPStagingCommon.showError(
                'Fatal Error:  ' + errorCode + ' Please try the <a href=\'https://wp-staging.com/docs/wp-staging-settings-for-small-servers/\' target=\'_blank\'>WP Staging Small Server Settings</a> or submit an error report and contact us.',
            );
          }
        },
        success: function(data) {
          if ('function' === typeof (callback)) {
            callback(data);
          }
        },
        statusCode: {
          404: function() {
            if (tryCount >= retryLimit) {
              WPStagingCommon.showError('Error 404 - Can\'t find ajax request URL! Please try the <a href=\'https://wp-staging.com/docs/wp-staging-settings-for-small-servers/\' target=\'_blank\'>WP Staging Small Server Settings</a> or submit an error report and contact us.');
            }
          },
          500: function() {
            if (tryCount >= retryLimit) {
              WPStagingCommon.showError('Fatal Error 500 - Internal server error while processing the request! Please try the <a href=\'https://wp-staging.com/docs/wp-staging-settings-for-small-servers/\' target=\'_blank\'>WP Staging Small Server Settings</a> or submit an error report and contact us.');
            }
          },
          504: function() {
            if (tryCount > retryLimit) {
              WPStagingCommon.showError('Error 504 - It looks like your server is rate limiting ajax requests. Please try to resume after a minute. If this still not works try the <a href=\'https://wp-staging.com/docs/wp-staging-settings-for-small-servers/\' target=\'_blank\'>WP Staging Small Server Settings</a> or submit an error report and contact us.\n\ ');
            }
          },
          502: function() {
            if (tryCount >= retryLimit) {
              WPStagingCommon.showError('Error 502 - It looks like your server is rate limiting ajax requests. Please try to resume after a minute. If this still not works try the <a href=\'https://wp-staging.com/docs/wp-staging-settings-for-small-servers/\' target=\'_blank\'>WP Staging Small Server Settings</a> or submit an error report and contact us.\n\ ');
            }
          },
          503: function() {
            if (tryCount >= retryLimit) {
              WPStagingCommon.showError('Error 503 - It looks like your server is rate limiting ajax requests. Please try to resume after a minute. If this still not works try the <a href=\'https://wp-staging.com/docs/wp-staging-settings-for-small-servers/\' target=\'_blank\'>WP Staging Small Server Settings</a> or submit an error report and contact us.\n\ ');
            }
          },
          429: function() {
            if (tryCount >= retryLimit) {
              WPStagingCommon.showError('Error 429 - It looks like your server is rate limiting ajax requests. Please try to resume after a minute. If this still not works try the <a href=\'https://wp-staging.com/docs/wp-staging-settings-for-small-servers/\' target=\'_blank\'>WP Staging Small Server Settings</a> or submit an error report and contact us.\n\ ');
            }
          },
          403: function() {
            if (tryCount >= retryLimit) {
              WPStagingCommon.showError('Refresh page or login again! The process should be finished successfully. \n\ ');
            }
          },
        },
      });
    },
  };

  return WPStagingCommon;
})(jQuery);
